import type { ColumnDef } from "@tanstack/table-core";

import { Badge } from "@/components/Badge";
import { DataTableColumnHeader } from "@/components/DataTable/Columns/DataTableColumnHeader";
import type { HelperOptions } from "@/components/DataTable/types";

export function appCategoryColumn<TData>(
  id: string,
  accessorFn: (row: TData) => string,
  options: HelperOptions,
): ColumnDef<TData> {
  const { i18nKey, minWidth = "160px", sortable = false } = options;
  return {
    accessorKey: id,
    accessorFn,
    meta: { i18nKey, thStyle: { minWidth } },
    enableSorting: sortable,
    header: DataTableColumnHeader,
    cell: ({ getValue }) => (
      <Badge variant={"neutralMuted"}>{getValue<string>()}</Badge>
    ),
  };
}
